export default {
  server_URL: 'https://api.rmscenariobuilder.com'
};